import request from "@/utils/request";

// 用户相关接口
export const userApi = {
  // 用户登录
  login: (data) => {
    return request({
      url: "/api/admin/base/open/login",
      method: "post",
      data,
    });
  },
  // 获取用户信息
  getUserInfo: () => {
    return request({
      url: "/api/admin/base/comm/person",
      method: "get",
    });
  },
  // 修改用户信息
  updateUserInfo: (data) => {
    return request({
      url: "/api/admin/base/comm/personUpdate",
      method: "post",
      data,
    });
  },
  //上传图片
  upload: (data) => {
    return request({
      url: "/api/admin/base/comm/upload",
      method: "post",
      data,
    });
  },
  //刷新token
  refreshToken: (data) => {
    return request({
      url: "/api/admin/base/open/refreshToken",
      method: "get",
      params: data,
    });
  },
  //生成获客二维码
  generateQrcode: () => {
    return request({
      url: "/api/admin/account/account/generateSalesQrCode",
      method: "get",
    });
  },
  // 系统消息列表
  getNotificationList: () => {
    return request({
      url: "/api/admin/account/notification/list",
      method: "post",
    });
  },
  // 系统消息列表-分页
  getNotificationPage: (data) => {
    return request({
      url: "/api/admin/account/notification/page",
      method: "post",
      data,
    });
  },
  // 发送风险验证码
  sendRiskVerifyCode: (data) => {
    return request({
      url: "/api/admin/base/open/sendRiskVerifyCode",
      method: "post",
      data,
    });
  },
  // 验证风险登录
  verifyRiskLogin: (data) => {
    return request({
      url: "/api/admin/base/open/verifyRiskLogin",
      method: "post",
      data,
    });
  },
  // 选择角色登录
  selectRole: (data) => {
    return request({
      url: "/api/admin/base/open/selectRole",
      method: "post",
      data,
    });
  },
  // 验证token
  verifyToken: (token) => {
    return request({
      url: "/api/admin/base/open/verifyToken",
      method: "post",
      data: { token },
    });
  },

  // 使用授权码获取token
  verifyAuthCodeAndGetToken: (authCode) => {
    return request({
      url: "/api/admin/base/open/verifyAuthCodeAndGetToken",
      method: "post",
      data: {
        authCode,
      },
    });
  },
};

// 账号相关接口
export const accountsApi = {
  // 获取首页推荐账号列表
  getList: (params) => {
    return request({
      url: "/api/admin/account/account/findShopAccount",
      method: "get",
      params,
    });
  },
  // 获取搜索账号列表-分页
  getPage: (data) => {
    return request({
      url: "/api/admin/account/shop/page",
      method: "post",
      data,
    });
  },
  // 获取收藏账号列表-分页
  getCollectionPage: (data) => {
    return request({
      url: "/api/admin/account/follow/page",
      method: "post",
      data,
    });
  },
  // 判断账号是否被收藏
  isCollection: (data) => {
    return request({
      url: "/api/admin/account/follow/check",
      method: "post",
      data,
    });
  },
  // 添加收藏账号
  addCollection: (data) => {
    return request({
      url: "/api/admin/account/follow/add",
      method: "post",
      data,
    });
  },
  // 取消收藏账号
  removeCollection: (data) => {
    return request({
      url: "/api/admin/account/follow/remove",
      method: "post",
      data,
    });
  },

  // 获取字典列表
  getDictInfoData: (data) => {
    return request({
      url: "/api/admin/dict/info/data",
      method: "post",
      data,
    });
  },
  // 获取账号详情
  getAccountDetail: (data) => {
    return request({
      url: "/api/admin/account/account/externalGetInfo",
      method: "post",
      data,
    });
  },
  // 获取反馈与建议列表-分页
  getFeedbackPage: (data) => {
    return request({
      url: "/api/admin/feedback/feedback/page",
      method: "post",
      data,
    });
  },

  // 新增反馈与建议
  addFeedback: (data) => {
    return request({
      url: "/api/admin/feedback/feedback/add",
      method: "post",
      data,
    });
  },
  // 获取投诉与举报列表-分页
  getComplaintPage: (data) => {
    return request({
      url: "/api/admin/complaint/complaint/page",
      method: "post",
      data,
    });
  },
  // 新增投诉与举报
  addComplaint: (data) => {
    return request({
      url: "/api/admin/complaint/complaint/add",
      method: "post",
      data,
    });
  },
  // 我的竞价统计
  getStatisticalData: (params) => {
    return request({
      url: "/api/admin/order/OrderController/statisticalData",
      method: "get",
      params,
    });
  },
  // 发起竞价
  addBid: (data) => {
    return request({
      url: "/api/admin/bidding/auction/add",
      method: "post",
      data,
    });
  },
  // 修改账号库账号
  updateAccount: (data) => {
    return request({
      url: "/api/admin/account/account/update",
      method: "post",
      data,
    });
  },
  //获取账号库账号信息
  getAccountInfoById: (data) => {
    return request({
      url: "/api/admin/account/shop/findShopLowestPrice",
      method: "post",
      data,
    });
  },
  // 我要购买
  retailBuy: (data) => {
    return request({
      url: "/api/admin/account/shop/retailBuy",
      method: "post",
      data,
    });
  },
  // 图片导出
  imagesVertically: (data) => {
    return request({
      url: "/api/admin/account/account/imagesVertically",
      method: "post",
      data,
    });
  },
  // 囤号库列表
  findShopStockAccount: (data) => {
    return request({
      url: "/api/admin/account/shop/findShopStockAccount",
      method: "post",
      data,
    });
  },
  // 黑名单列表-分页
  getBlockAccountPage: (data) => {
    return request({
      url: "/api/admin/account/block/page",
      method: "post",
      data,
    });
  },
  // 账号监控列表-分页
  getMonitoringAccountPage: (data) => {
    return request({
      url: "/api/admin/account/monitoring/page",
      method: "post",
      data,
    });
  },
  // 账号监控-新增
  addMonitoringAccount: (data) => {
    return request({
      url: "/api/admin/account/monitoring/add",
      method: "post",
      data,
    });
  },
  // 账号监控-修改
  updateMonitoringAccount: (data) => {
    return request({
      url: "/api/admin/account/monitoring/update",
      method: "post",
      data,
    });
  },
  // 账号监控-删除
  deleteMonitoringAccount: (data) => {
    return request({
      url: "/api/admin/account/monitoring/delete",
      method: "post",
      data,
    });
  },
  // 账号监控-新增策略-followUp-purchaseId-remark
  addPurchasePloy: (data) => {
    return request({
      url: "/api/admin/purchase/ploy/add",
      method: "post",
      data,
    });
  },
  // 账号监控策略列表-purchaseId
  getPurchasePloyList: (data) => {
    return request({
      url: "/api/admin/purchase/ploy/list",
      method: "post",
      data,
    });
  },

  // 策略标记为已读-customerId
  markAsReadPurchasePloy: (data) => {
    return request({
      url: "/api/admin/purchase/ploy/markAsRead",
      method: "post",
      data,
    });
  },
  // 查看未读消息数量
  getPurchaseUnreadCount: (data) => {
    return request({
      url: "/api/admin/purchase/ploy/getBatchUnreadCount",
      method: "post",
      data,
    });
  },
};

// 客户相关接口
export const customerApi = {
  // 获取责任人列表
  getUserList: (params) => {
    return request({
      url: "/api/admin/crm/customer/getUserList",
      method: "get",
      params,
    });
  },
  // 获取所在组织列表
  getDepartmentList: (data) => {
    return request({
      url: "/api/admin/base/sys/department/list",
      method: "post",
      data,
    });
  },
  // 获取客户列表
  getCustomerPage: (data) => {
    return request({
      url: "/api/admin/crm/customer/page",
      method: "post",
      data,
    });
  },
  // 新增客户
  addCustomer: (data) => {
    return request({
      url: "/api/admin/crm/customer/add",
      method: "post",
      data,
    });
  },
  // 修改客户
  updateCustomer: (data) => {
    return request({
      url: "/api/admin/crm/customer/update",
      method: "post",
      data,
    });
  },
  // 删除客户
  deleteCustomer: (data) => {
    return request({
      url: "/api/admin/crm/customer/delete",
      method: "post",
      data,
    });
  },
  // 批量转移客户
  batchTransferCustomer: (data) => {
    return request({
      url: "/api/admin/crm/customer/batchTransfer",
      method: "post",
      data,
    });
  },
  // 获取公海客户列表-分页
  getPoolCustomerPage: (data) => {
    return request({
      url: "/api/admin/crm/pool/page",
      method: "post",
      data,
    });
  },
  // 领取客户
  receiveCustomer: (data) => {
    return request({
      url: "/api/admin/crm/customer/receiveCustomer",
      method: "post",
      data,
    });
  },
  // 分配客户
  allocationCustomer: (data) => {
    return request({
      url: "/api/admin/crm/customer/allocationCustomer",
      method: "post",
      data,
    });
  },
  // 客户信息
  getCustomerInfo: (data) => {
    return request({
      url: "/api/admin/crm/customer/getCustomerInfo",
      method: "post",
      data,
    });
  },
  // 获取跟进记录-分页
  getFollowPage: (data) => {
    return request({
      url: "/api/admin/crm/follow/page",
      method: "post",
      data,
    });
  },
  // 放入公海
  putInPool: (data) => {
    return request({
      url: "/api/admin/crm/customer/putInPool",
      method: "post",
      data,
    });
  },
  // 查询该客户下的所有账号
  getAccountsByCustomerId: (data) => {
    return request({
      url: "/api/admin/crm/customer/getAccountsByCustomerId",
      method: "post",
      data,
    });
  },
  // 今日需联系客户-分页
  getTodayNeedContactCustomer: (data) => {
    return request({
      url: "/api/admin/crm/customer/getTodayNeedContactCustomer",
      method: "post",
      data,
    });
  },
  // 分配给我的客户-分页
  getMyCustomer: (data) => {
    return request({
      url: "/api/admin/crm/customer/getMyCustomer",
      method: "post",
      data,
    });
  },
  // 新增跟进记录
  addFollowRecord: (data) => {
    return request({
      url: "/api/admin/crm/follow/add",
      method: "post",
      data,
    });
  },
  // 删除跟进记录
  deleteFollowRecord: (data) => {
    return request({
      url: "/api/admin/crm/follow/delete",
      method: "post",
      data,
    });
  },
  // 获取当前用户负责的客户
  getMyCustomer: () => {
    return request({
      url: "/api/admin/account/account/getCustomer",
      method: "get",
    });
  },
  // 用户策略列表
  getCrmPloyList: (data) => {
    return request({
      url: "/api/admin/crm/ploy/list",
      method: "post",
      data,
    });
  },
  // 新增策略--回复需要传一个parentId做区分
  addCrmPloyList: (data) => {
    return request({
      url: "/api/admin/crm/ploy/add",
      method: "post",
      data,
    });
  },
  // 策略标记为已读-customerId
  markAsReadCrmPloy: (data) => {
    return request({
      url: "/api/admin/crm/ploy/markAsRead",
      method: "post",
      data,
    });
  },
  // 查看未读消息数量
  getCrmUnreadCount: (data) => {
    return request({
      url: "/api/admin/crm/ploy/getBatchUnreadCount",
      method: "post",
      data,
    });
  },
};

// 论坛相关接口
export const forumApi = {
  // 获取广场列表
  getForumSquareList: (data) => {
    return request({
      url: "/api/admin/forum/article/squareList",
      method: "post",
      data,
    });
  },
  // 获取热榜列表
  getForumHotList: (data) => {
    return request({
      url: "/api/admin/forum/article/hotList",
      method: "post",
      data,
    });
  },
  // 获取关注列表
  getForumFollowList: (data) => {
    return request({
      url: "/api/admin/forum/follow/page",
      method: "post",
      data,
    });
  },
  // 获取自己的文章
  getForumArticlePage: (data) => {
    return request({
      url: "/api/admin/forum/article/page",
      method: "post",
      data,
    });
  },
  // 新增论坛文章
  addForumArticle: (data) => {
    return request({
      url: "/api/admin/forum/article/add",
      method: "post",
      data,
    });
  },
  // 点赞/取消点赞文章
  likeForumArticle: (data) => {
    return request({
      url: "/api/admin/forum/article/toggleLikeArticle",
      method: "post",
      data,
    });
  },
  // 踩/取消踩
  dislikeForumArticle: (data) => {
    return request({
      url: "/api/admin/forum/article/toggleDislikeArticle",
      method: "post",
      data,
    });
  },
  // 收藏/取消收藏
  favoriteForumArticle: (data) => {
    return request({
      url: "/api/admin/forum/article/toggleFavoriteArticle",
      method: "post",
      data,
    });
  },
  // 获取文章详情以及评论
  getArticleWithComments: (data) => {
    return request({
      url: "/api/admin/forum/article/articleWithComments",
      method: "post",
      data,
    });
  },
  // 新增评论
  addComment: (data) => {
    return request({
      url: "/api/admin/forum/comment/add",
      method: "post",
      data,
    });
  },
  // 点赞评论回复
  toggleLikeComment: (data) => {
    return request({
      url: "/api/admin/forum/comment/toggleLikeComment",
      method: "post",
      data,
    });
  },
  // 新增专栏
  addForumColumn: (data) => {
    return request({
      url: "/api/admin/forum/column/add",
      method: "post",
      data,
    });
  },
  // 收录至专栏
  addForumItem: (data) => {
    return request({
      url: "/api/admin/forum/item/add",
      method: "post",
      data,
    });
  },
  // 最新问题列表
  getNewQuestion: (data) => {
    return request({
      url: "/api/admin/forum/question/newQuestion",
      method: "post",
      data,
    });
  },
  // 人气问题列表
  getHotQuestion: (data) => {
    return request({
      url: "/api/admin/forum/question/hotQuestion",
      method: "post",
      data,
    });
  },
  // 关注问题
  questionFollow: (data) => {
    return request({
      url: "/api/admin/forum/follow/questionFollow",
      method: "post",
      data,
    });
  },
  // 新增问题列表
  addForumQuestion: (data) => {
    return request({
      url: "/api/admin/forum/question/add",
      method: "post",
      data,
    });
  },
  // 根据评论id获取回复的分页
  getRepliesByCommentId: (data) => {
    return request({
      url: "/api/admin/forum/comment/getRepliesByCommentId",
      method: "post",
      data,
    });
  },
  // 收藏问题
  toggleFavoriteQuestion: (data) => {
    return request({
      url: "/api/admin/forum/question/toggleFavoriteQuestion",
      method: "post",
      data,
    });
  },
  // 关注问题
  toggleFollowQuestion: (data) => {
    return request({
      url: "/api/admin/forum/question/toggleFollowQuestion",
      method: "post",
      data,
    });
  },
  // 获取回答和评论
  answerWithComments: (data) => {
    return request({
      url: "/api/admin/forum/answer/answerWithComments",
      method: "post",
      data,
    });
  },
  // 获取提问和回答
  questionWithAnswers: (data) => {
    return request({
      url: "/api/admin/forum/question/questionWithAnswers",
      method: "post",
      data,
    });
  },
  // 点赞/取消点赞问题
  toggleLikeQuestion: (data) => {
    return request({
      url: "/api/admin/forum/question/toggleLikeQuestion",
      method: "post",
      data,
    });
  },
  // 踩/取消踩问题
  toggleDislikeQuestion: (data) => {
    return request({
      url: "/api/admin/forum/question/toggleDislikeQuestion",
      method: "post",
      data,
    });
  },
  // 新增问题回答
  addForumAnswer: (data) => {
    return request({
      url: "/api/admin/forum/answer/add",
      method: "post",
      data,
    });
  },
  // 点赞/取消点赞回答
  toggleLikeAnswer: (data) => {
    return request({
      url: "/api/admin/forum/answer/toggleLikeAnswer",
      method: "post",
      data,
    });
  },
  // 踩/取消踩回答
  toggleDislikeAnswer: (data) => {
    return request({
      url: "/api/admin/forum/answer/toggleDislikeAnswer",
      method: "post",
      data,
    });
  },
  // 收藏評論
  toggleFavoriteAnswer: (data) => {
    return request({
      url: "/api/admin/forum/answer/toggleFavoriteAnswer",
      method: "post",
      data,
    });
  },
  // 查询我的回答
  getForumAnswerPage: (data) => {
    return request({
      url: "/api/admin/forum/answer/page",
      method: "post",
      data,
    });
  },
  // 删除我的回答
  deleteForumAnswer: (data) => {
    return request({
      url: "/api/admin/forum/answer/delete",
      method: "post",
      data,
    });
  },
  // 编辑我的回答
  updateForumAnswer: (data) => {
    return request({
      url: "/api/admin/forum/answer/update",
      method: "post",
      data,
    });
  },
  // 查询我的专栏
  getForumColumnPage: (data) => {
    return request({
      url: "/api/admin/forum/column/page",
      method: "post",
      data,
    });
  },
  // 新增专栏
  addForumColumn: (data) => {
    return request({
      url: "/api/admin/forum/column/add",
      method: "post",
      data,
    });
  },
  // 编辑专栏
  updateForumColumn: (data) => {
    return request({
      url: "/api/admin/forum/column/update",
      method: "post",
      data,
    });
  },
  // 删除专栏
  deleteForumColumn: (data) => {
    return request({
      url: "/api/admin/forum/column/delete",
      method: "post",
      data,
    });
  },
  // 查询某个专栏中的所有问题或者文章
  getForumColumnPageItem: (data) => {
    return request({
      url: "/api/admin/forum/column/pageItem",
      method: "post",
      data,
    });
  },
  // 查詢我的文章
  getForumArticlePage: (data) => {
    return request({
      url: "/api/admin/forum/article/page",
      method: "post",
      data,
    });
  },
  // 查詢我的提问
  getForumQuestionPage: (data) => {
    return request({
      url: "/api/admin/forum/question/page",
      method: "post",
      data,
    });
  },
  // 查詢我的收藏
  getMyFavorite: (data) => {
    return request({
      url: "/api/admin/forum/interaction/getMyFavorite",
      method: "post",
      data,
    });
  },
  // 查询属于自己的专栏(不分页)
  getMyColumn: (params) => {
    return request({
      url: "/api/admin/forum/column/getMyColumn",
      method: "get",
      params,
    });
  },
  // 查询所有的专栏
  getAllColumn: (data) => {
    return request({
      url: "/api/admin/forum/column/getAllColumn",
      method: "post",
      data,
    });
  },
  // 获取浏览记录（包含文章和提问）
  getForumHistoryPage: (data) => {
    return request({
      url: "/api/admin/forum/history/page",
      method: "post",
      data,
    });
  },
  // 取消收录
  deleteForumItem: (data) => {
    return request({
      url: "/api/admin/forum/item/deletedItem",
      method: "post",
      data,
    });
  },
  // 删除文章
  deleteForumArticle: (data) => {
    return request({
      url: "/api/admin/forum/article/delete",
      method: "post",
      data,
    });
  },
  // 删除提问
  deleteForumQuestion: (data) => {
    return request({
      url: "/api/admin/forum/question/delete",
      method: "post",
      data,
    });
  },
  // 修改文章
  updateForumArticle: (data) => {
    return request({
      url: "/api/admin/forum/article/update",
      method: "post",
      data,
    });
  },
};
